import React, { useEffect, useState } from "react";
import moment from "moment";
import LANGS from "global/lang";
import ExternalLinkView from "./ExternalLinkView";
import { getExternalLinks } from "services/services";
import { useHistory } from "react-router-dom";
import { EXTERNAL_LINK_EDIT } from "navigation/CONSTANTS";
import { Edit } from "@material-ui/icons";
import Button from "components/Button";

export function languagesSelectList() {
  return [{ value: 0, display: "Todos" }].concat(
    LANGS.sort((a, b) => a.order - b.order).map((l) => ({
      value: l.id,
      display: l.display,
    }))
  );
}

export function ExternalLinkContainer() {
  const [externalLinks, setExternalLinks] = useState([]);
  const [language, setLanguage] = useState(0);
  const history = useHistory();
  const langIds = LANGS.map((l) => l.id);

  useEffect(() => {
    fetchExternalLinks(Number(language) ? [language] : langIds);
  }, [language]);

  function handleEdit(id) {
    history.push(`${EXTERNAL_LINK_EDIT}/${id}`);
  }

  function handleNew() {
    history.push(`${EXTERNAL_LINK_EDIT}/0`);
  }

  async function fetchExternalLinks(langs) {
    const res = await getExternalLinks({}, langs);
    if (res?.data) adjustData(res.data);
    setExternalLinks(res.data || []);
  }

  function adjustData(links) {
    links.forEach((externalLink) => {
      externalLink.from = moment(externalLink.from).format("YYYY-MM-DD");
      externalLink.to = moment(externalLink.to).format("YYYY-MM-DD");
      externalLink.language = LANGS.find(
        (l) =>
          l.code.toUpperCase() === String(externalLink.language?.code).toUpperCase()
      )?.display;
      externalLink.actions = [
        <Button
          key={externalLink.id}
          icon={<Edit />}
          onClick={() => handleEdit(externalLink.id)}
          testid={`btn_edit_externalLink_${externalLink.id}`}
          data-testid={`btn_edit_externalLink_${externalLink.id}`}
          variant="text"
          color="primary"
        />,
      ];
    });
    return links;
  }

  return (
    <div data-testid="external_links_list_container">
      <ExternalLinkView
        languages={languagesSelectList()}
        selectedLanguage={language}
        handlerChangeLanguage={(e) => setLanguage(String(e.target.value))}
        externalLinks={externalLinks}
        handleNew={handleNew}
      />
    </div>
  );
}
